// removed by extract-text-webpack-plugin
module.exports = {"container":"_2Mef","fake":"xF3q","red":"_1eNw","blue":"_3UVJ","green":"_3oMU","dark-blue":"_2Nm-","yellow":"_3035","purple":"_1pW5","pink":"_2m60","toc":"_2DmP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Below/styles.scss
// module id = 159
// module chunks = 0